export const KYC_STATUS_VARIANTS = {
  BANK_VERIFIED: "BANK_VERIFIED",
  PAN_NOT_SUBMITTED: "PAN_NOT_SUBMITTED",
  PAN_VERIFIED: "PAN_VERIFIED",
  VERIFIED: "VERIFIED",
  PENDING: "PENDING",
  KYC_INITIATED: "KYC_INITIATED",
  /** Legacy — backend no longer emits this; kept so old branches do not break. */
  VERIFIED_NOT_SUBMITTED: "VERIFIED_NOT_SUBMITTED",
  GST_VERIFIED: "GST_VERIFIED",
  PENDING_REVIEW: "PENDING_REVIEW",
  ON_HOLD: "ON_HOLD",
  PENDING_SAP_CODE: "PENDING_SAP_CODE",
  REJECTED: "REJECTED",
} as const;

export type KycStatusVariant =
  (typeof KYC_STATUS_VARIANTS)[keyof typeof KYC_STATUS_VARIANTS];

/** GBS / review-queue states: partner cannot edit; show the read-only under-review screen. */
export const KYC_UNDER_REVIEW_STATUSES: ReadonlySet<string> = new Set([
  KYC_STATUS_VARIANTS.PENDING_REVIEW,
  KYC_STATUS_VARIANTS.ON_HOLD,
  KYC_STATUS_VARIANTS.PENDING_SAP_CODE,
]);

export function isKycUnderReviewStatus(status?: string | null): boolean {
  return Boolean(status && KYC_UNDER_REVIEW_STATUSES.has(status));
}

export function isKnownKycStatus(status?: string | null): boolean {
  if (!status) return false;
  return (Object.values(KYC_STATUS_VARIANTS) as string[]).includes(status);
}
